import WarehouseMasterView from './WarehouseView';
export default WarehouseMasterView;